import PropTypes from "prop-types";

import ACL_RELATIONSHIPS from "acl-relationships";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import { useContactNavigation } from "routes/contact/useContactNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.entityContact.create,
  ACL_RELATIONSHIPS.entityForFilters.read,
];

/** The table's create action, preset with the parent the table is scoped by. */
const NewContactButton = ({ entityId, campaignId }) => {
  const { openCreate } = useContactNavigation();

  return (
    <TableCreateButton
      permissions={CREATE_ACLS}
      onClick={() => openCreate({ entityId, campaignId })}
    >
      New Contact
    </TableCreateButton>
  );
};

const idType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

NewContactButton.propTypes = {
  entityId: idType,
  campaignId: idType,
};

export default NewContactButton;
